<template>
  <div class="spacer-block" :style="{ height: spacerHeight }" />
</template>

<script>
export default {
  name: 'SpacerBlock',
  props: {
    data: {
      type: Object,
      required: true,
      validator: (value) => {
        return value.height !== undefined
      }
    }
  },
  computed: {
    spacerHeight() {
      const { height, customHeight } = this.data

      // Preset heights
      const presets = {
        small: '20px',
        medium: '40px',
        large: '80px'
      }

      // If custom height is specified, use it
      if (height === 'custom' && customHeight) {
        return `${customHeight}px`
      }

      // Otherwise use preset
      return presets[height] || presets.medium
    }
  }
}
</script>

<style scoped>
.spacer-block {
  width: 100%;
}
</style>
